<template>
  <div>
    <Toolbar classes="pt-3">
      <template v-slot:actions>
        <div class="d-flex align-items-center">
          <router-link to="/subscription" class="btn btn-sm btn-primary">
            <i class="bi bi-arrow-left me-1"></i>
            Voltar
          </router-link>
        </div>
      </template>
    </Toolbar>
    <div class="container-xxl">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Faturas</h3>
        </div>
        <div class="card-body table-responsive">
          <table class="table table-row-bordered">
            <thead>
              <tr>
                <th>Referência</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Status</th>
                <th>Forma</th>
                <th>Tentativas</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="charge in charges" :key="charge.id_place_platform_charge">
                <td>{{ charge.charge_reference }}</td>
                <td>{{ formatDate(charge.charge_due_date) }}</td>
                <td>R$ {{ formatMoney(charge.charge_amount) }}</td>
                <td>{{ charge.charge_status_label || charge.charge_status }}</td>
                <td>{{ charge.payment_method_label || '-' }}</td>
                <td>
                  <span v-if="charge.payment_method === 'credit_card'">{{ charge.retry_count || 0 }}</span>
                  <span v-else>-</span>
                </td>
                <td class="text-nowrap">
                  <button
                    v-if="canManage && charge.charge_status !== 'paid'"
                    class="btn btn-sm btn-primary me-1"
                    @click="openPayModal(charge)"
                  >
                    Pagar
                  </button>
                  <a
                    v-if="charge.boleto_url"
                    :href="charge.boleto_url"
                    target="_blank"
                    class="btn btn-sm btn-light"
                  >
                    Boleto
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <PlatformSubscriptionPayChargeModal
      :charge="selectedCharge"
      :default-payment-method="defaultPaymentMethod"
      :has-saved-card="hasSavedCard"
      @paid="load"
      @close="selectedCharge = null"
    />
  </div>
</template>

<script>
import Toolbar from '../../components/layouts/auth/Toolbar.vue';
import PlatformSubscriptionPayChargeModal from './PlatformSubscriptionPayChargeModal.vue';
import http from '../../helpers/http';
import Permission from '../../helpers/permission';
import moment from 'moment';

export default {
  name: 'SubscriptionInvoices',
  components: { Toolbar, PlatformSubscriptionPayChargeModal },
  data() {
    return {
      charges: [],
      selectedCharge: null,
      defaultPaymentMethod: null,
      hasSavedCard: false,
    };
  },
  computed: {
    canManage() {
      return Permission.has('Manage Place Platform Subscription');
    },
  },
  created() {
    if (!Permission.has('View Place Platform Subscription')) {
      this.$router.replace('/dashboard');
      return;
    }
    this.load();
    this.loadPaymentMethod();
  },
  methods: {
    load() {
      const placeId = this.$store.state.auth.place?.id_place;
      http.get(`/places/${placeId}/platform-subscription/charges`).then((res) => {
        this.charges = res.data.data || res.data;
      });
    },
    loadPaymentMethod() {
      const placeId = this.$store.state.auth.place?.id_place;
      http.get(`/places/${placeId}/platform-subscription/payment-method`).then((res) => {
        this.defaultPaymentMethod = res.data.payment_method;
        this.hasSavedCard = !!res.data.card;
      });
    },
    formatDate(value) {
      if (!value) {
        return '—';
      }

      return moment(value).format('DD/MM/YYYY');
    },
    formatMoney(value) {
      return Number(value).toFixed(2).replace('.', ',');
    },
    openPayModal(charge) {
      this.selectedCharge = { ...charge };
    },
  },
};
</script>
